import axios from "axios";
import { Base_URL } from "../url";

export const saveCostCenter = async (costCenterData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CostCenterMaster/CreateCostCenter?UserName=${userName}`,
      costCenterData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving cost center details!";
  }
};

export const getAllDepartments = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/DepartmentMaster/GetAllDepartments`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching departments!";
  }
};